import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import React from "react";
import {
  BaseGrid,
  StyledTableRow,
  TableCellHeader,
  TableCellWidth,
  TitleTypography,
} from "../KandidatViewPage";
import { BahasaResponse } from "../../../models/Bahasa";

type Props = { data: BahasaResponse[] };

export default function DataBahasaKandidatPage({ data }: Props) {
  return (
    <BaseGrid container item xs={12} justifyContent="center">
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
          marginBottom: "4%",
        }}
      >
        <TitleTypography>Data Bahasa</TitleTypography>
      </Grid>
      <Grid container item xs={12}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
                <TableCellHeader>Bahasa</TableCellHeader>
                <TableCellHeader>Membaca</TableCellHeader>
                <TableCellHeader>Mendengar</TableCellHeader>
                <TableCellHeader>Menulis</TableCellHeader>
                <TableCellHeader>Berbicara</TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, key) => (
                <StyledTableRow key={key}>
                  <TableCellWidth>{row.BAHASA}</TableCellWidth>
                  <TableCellWidth>{row.MEMBACA}</TableCellWidth>
                  <TableCellWidth>{row.MENDENGAR}</TableCellWidth>
                  <TableCellWidth>{row.MENULIS}</TableCellWidth>
                  <TableCellWidth>{row.BERBICARA}</TableCellWidth>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </BaseGrid>
  );
}
